import { useMemo } from 'react';
import { useApps, useBuilds, useProjects, useQueue } from '@/api/hooks';
import type { BuildsSearch } from '@/router';
import { buildFilters } from './buildsPageModel';
import { useBuildsLive } from './useBuildsLive';

/** Everything the builds page reads: the project of the URL, its apps, the filtered builds, the queue and the live stream. */
export function useBuildsPageData(slug: string, search: BuildsSearch) {
  const projects = useProjects();
  const project = projects.data?.find((p) => p.slug === slug);
  const apps = useApps(project?.id);
  const filters = useMemo(() => buildFilters(project?.id, search), [project?.id, search]);
  const builds = useBuilds(filters, Boolean(project));
  const queue = useQueue(project?.id, Boolean(project));
  const live = useBuildsLive(project?.id);
  const rows = builds.data?.pages.flatMap((p) => p.data);
  return { projects, project, apps, builds, queue, live, rows };
}

export type BuildsPageData = ReturnType<typeof useBuildsPageData>;
